import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { ChangerPassword } from "src/app/parametrage/core/model/employee/changer-password";
import { EmployeeService } from "src/app/parametrage/core/service/employee.service";

interface Alert {
  type: string;
  message: string;
}

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.scss"],
})
export class ChangePasswordComponent implements OnInit {
  alerts: Alert[] = [];

  changePassword: ChangerPassword = new ChangerPassword();

  pressButton: Boolean = false;
  form: FormGroup;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _employeeService: EmployeeService,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      newPassword: [
        "",
        [
          Validators.compose([Validators.required]),
          Validators.compose([Validators.minLength(6)]),
        ],
      ],
      confirmPassword: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {}

  save(): void {
    this.alerts = [];
    this._employeeService
      .changerPassword(this.changePassword)
      .pipe(first())
      .subscribe(
        (data) => {
          this.alerts.push({
            type: "success",
            message: "Les modifications ont été enregistrées",
          });
        },
        (error) => {
          console.log(error);

          this.alerts.push({
            type: "danger",
            message: error.error.message,
          });
        }
      );
  }

  close(alert: Alert) {
    this.alerts.splice(this.alerts.indexOf(alert), 1);
  }
}
